module.exports = {"469024100":"临城镇","469024101":"波莲镇","469024102":"东英镇","469024103":"博厚镇","469024104":"皇桐镇","469024105":"多文镇","469024106":"和舍镇","469024107":"南宝镇","469024108":"新盈镇","469024109":"调楼镇","469024400":"国营红华农场","469024401":"国营加来农场"}


//////////////////
// WEBPACK FOOTER
// ./src/town/469024.json
// module id = 2028
// module chunks = 0